import React, {Suspense} from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {DriverProvider, NotificationsProvider, StorageProvider} from './@contexts'
import AuthInit_ from './modules/auth/redux/AuthInit_'

type Props = {
    basename: string
}

const App: React.FC<Props> = ({basename}) => {

    console.log("*** hello World! ***")


    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter basename={basename}>
                {/*<DateRangeProvider>{*/}
                <I18nProvider>
                    {/*<BacktrackingProvider>{*/}
                    <LayoutProvider>
                        <AuthInit_>
                            <DriverProvider>
                                <NotificationsProvider>
                                    <StorageProvider>
                                        <Routes />
                                    </StorageProvider>
                                </NotificationsProvider>
                            </DriverProvider>
                        </AuthInit_>
                    </LayoutProvider>
                    {/* </BacktrackingProvider>{*/}
                </I18nProvider>
                {/*</DateRangeProvider>{*/}
            </BrowserRouter>
        </Suspense>
    )
}

export {App}
